<template>
    <section class="chart-panel" :aria-label="`${title}, ${unit}`">
        <header class="plot-heading"><strong>{{ subtitle || unit }}<small v-if="subtitle" class="d-block text-muted mt-1">{{ unit }}</small></strong><button class="btn btn-sm btn-outline-secondary" @click="download">Скачать PNG</button></header>
        <div class="plot-canvas"><canvas ref="canvas" role="img" :aria-label="`${title}. Точные значения доступны в режиме таблицы.`"></canvas></div>
    </section>
</template>
<script>
import Chart from 'chart.js/auto';
export default {
    name: 'ChartsPlot',
    props: {series: Array, colors: Object, offset: Boolean, title: String, subtitle: String, unit: String, period: Object},
    mounted() { this.draw(); },
    beforeDestroy() { if (this.chartInstance) this.chartInstance.destroy(); },
    watch: {series() { this.draw(); }, offset() { this.draw(); }},
    methods: {
        draw() {
            if (!this.$refs.canvas) return;
            if (this.chartInstance) this.chartInstance.destroy();
            this.chartInstance = new Chart(this.$refs.canvas, this.configuration());
        },
        configuration(exporting = false) {
            const offset = this.offset;
            const dates = this.series.length ? this.series[0].points.map(point => point.date) : [];
            return {
                type: 'line',
                data: {labels: offset ? undefined : dates, datasets: this.series.map((item, index) => ({
                    label: item.label, data: item.points.filter(point => !offset || point.day >= 1).map(point => ({
                        x: offset ? point.day : point.date, y: point.value, date: point.date, numerator: point.numerator, denominator: point.denominator
                    })), borderColor: this.colors[item.id], backgroundColor: this.colors[item.id],
                    borderWidth: 2, pointRadius: dates.length > 90 ? 0 : 2, pointHitRadius: 12,
                    borderDash: index >= 8 ? [5, 4] : [], tension: 0, spanGaps: false
                }))},
                options: {responsive: !exporting, maintainAspectRatio: false, animation: false, devicePixelRatio: exporting ? 2 : undefined,
                    interaction: {mode: 'index', intersect: false},
                    plugins: {legend: {display: false}, tooltip: {callbacks: {
                        title: items => items.length ? offset ? `День ${items[0].parsed.x}` : items[0].raw.date.split('-').reverse().join('.') : '',
                        label: ctx => `${ctx.dataset.label}: ${ctx.parsed.y === null ? 'нет данных' : ctx.parsed.y.toLocaleString('ru-RU')} ${this.unit}`,
                        afterLabel: ctx => [offset ? `Дата: ${ctx.raw.date.split('-').reverse().join('.')}` : '',
                            ctx.raw.denominator !== null ? `Расчёт: ${ctx.raw.numerator} / ${ctx.raw.denominator}` : ''].filter(Boolean)
                    }}},
                    scales: {x: {type: offset ? 'linear' : 'category', min: offset ? 1 : undefined,
                        title: {display: offset, text: 'Дни от начала выбранной работы'},
                        ticks: {maxTicksLimit: 10, maxRotation: 0, precision: 0, callback(value) {
                            if (offset) return value;
                            const [year, month, day] = this.getLabelForValue(value).split('-');
                            return [`${day}.${month}`, year];
                        }}, grid: {display: false}},
                    y: {beginAtZero: true, ticks: {maxTicksLimit: 7}, grid: {color: '#edf0f5'}}}
                }
            };
        },
        download() {
            const source = document.createElement('canvas'), canvas = document.createElement('canvas');
            source.width = 1200; source.height = 460;
            const exportedChart = new Chart(source, this.configuration(true));
            const width = 1200, lines = [];
            const ctx = canvas.getContext('2d'); ctx.font = '16px sans-serif';
            this.series.forEach(item => {
                const words = item.label.split(' '); let line = '';
                words.forEach(word => { if (ctx.measureText(line + ' ' + word).width > width - 100) { lines.push({text: line, color: this.colors[item.id]}); line = ''; } line += (line ? ' ' : '') + word; });
                lines.push({text: line, color: this.colors[item.id]});
            });
            const header = 112 + lines.length * 24, height = source.height * width / source.width;
            canvas.width = width; canvas.height = header + height + 24;
            ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.fillStyle = '#17253a'; ctx.font = 'bold 24px sans-serif'; ctx.fillText(this.title, 28, 36, width - 56);
            ctx.font = '16px sans-serif'; ctx.fillText(`${this.period.start} — ${this.period.end} · ${this.unit}`, 28, 65);
            ctx.fillText(this.offset ? 'По дням от начала работы. Реальные даты доступны в таблице.' : 'Календарные даты', 28, 90);
            lines.forEach((line, index) => {ctx.fillStyle = line.color; ctx.fillRect(28, 110 + index * 24, 20, 3); ctx.fillStyle = '#17253a'; ctx.fillText(line.text, 58, 117 + index * 24);});
            ctx.drawImage(source, 0, header, width, height);
            exportedChart.destroy();
            const link = document.createElement('a'); link.download = `Графики_${this.period.start}_${this.period.end}.png`; link.href = canvas.toDataURL('image/png'); link.click();
        }
    }
};
</script>
<style scoped>
.chart-panel{background:#fff;border:1px solid #e1e7ef;border-radius:14px;padding:18px;margin-top:14px;min-width:0}
.plot-heading{display:flex;align-items:center;justify-content:space-between;gap:12px;color:#52627a;margin-bottom:14px}
.plot-heading strong{min-width:0;overflow-wrap:anywhere}.plot-heading .btn{flex-shrink:0}
.plot-canvas{position:relative;height:340px;min-width:0}
@media(max-width:767px){.chart-panel{padding:12px}.plot-canvas{height:300px}}
</style>
